import { createSelector } from 'reselect'

import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.VIDEO_LESSON_STREAMLINE,
	featureFlagsTypes.MY_VIDEOS_PICKER_TAB,
])

const routeSelector = createSelector([featureFlagsSelector], featureFlags => {
	const shouldUseVideoSreamlineNewRoutes = featureFlags[featureFlagsTypes.VIDEO_LESSON_STREAMLINE]
	return {
		shouldUseVideoSreamlineNewRoutes,
	}
})

export default routeSelector
